import { render, staticRenderFns } from "./ClubView.vue?vue&type=template&id=8c6b8de2"
import script from "./ClubView.vue?vue&type=script&lang=js"
export * from "./ClubView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports